<div class="container">
  <h5>{{'ROOM_SEARCH_TITLE'|translate}}
    <button type="button" class="btn btn-link" (click)="toggleInfoTextCollapse()"
      [attr.aria-expanded]="!isCollapsedInfoText" aria-controls="collapseExample">
      <span *ngIf="isCollapsedInfoText" class="oi oi-plus" title="icon plus" aria-hidden="true"></span>
      <span *ngIf="!isCollapsedInfoText" class="oi oi-minus" title="icon minus" aria-hidden="true"></span>
    </button>
  </h5>
  <p [ngbCollapse]="isCollapsedInfoText">{{'ROOM_SEARCH_INFO'|translate}}</p>
</div>

<!-- FIXME -->
<!-- <app-debug-multi-dropdown></app-debug-multi-dropdown> -->

<div class="container">

  <div appAccordion>
    <div [id]="accordionSearchPanel" [expanded]='isSearchPanelExpaneded' appAccordionElement
      (collapsedChanged)="collapseChanedReactor($event)">

      <div appAccordionElementHeader>
        <button type="button" appAccordionElementTrigger>{{'SEARCH'|translate}}</button>
        <app-search-terms-favorizer *ngIf="isSearchPanelExpaneded" class="float-right"></app-search-terms-favorizer>
      </div>

      <app-accordion-element-body>
        <div class="card-body">

          <form [formGroup]="searchFormGroup">

            <!-- number, date and availability part of searchForm -->
            <app-main-search-input [searchForm]="searchFormGroup" [numberCaption]="'ROOMNUMBER'|translate"
              [numberSubCaption]="'ROOMNUMBER_SUB'|translate" [checkboxCaption]="'SHOW_ONLY_AVAILABLE_ROOMS'|translate">

              <!-- Standort -->
              <app-form-group formControlName="location" id="inputTestDropDown" [selectData]="locations"
                class="col-sm-6" type="multi-dropdown" text="{{'LOCATION'|translate}}"></app-form-group>
              <!-- Gebäude -->
              <app-form-group formControlName="building" id="dropdownBuilding" [selectData]="buildings" class="col-sm-6"
                type="multi-dropdown" text="{{'BUILDING'|translate}}"></app-form-group>
            </app-main-search-input>

            <hr />

            <div class="row">
              <div class="col-6">
                <app-button text="{{'EXTENDED_SEARCH'|translate}}" btnClass="px-0" btnStyle="link"
                  (click)="onToggleExtendedSearch()" [attr.aria-expanded]="searchFormGroup.value.showExtendedSearch"
                  aria-controls="collapseExample" [icon]="searchFormGroup.value.showExtendedSearch ? 'minus' : 'plus'">
                </app-button>
              </div>

              <div id="collapseExample" [ngbCollapse]="!searchFormGroup.value.showExtendedSearch" class="col-12">
                <div class="row" *ngIf="!!searchFormGroup.value.showExtendedSearch">
                  <!-- Raumtyp -->
                  <app-form-group formControlName="roomType" id="dropdownRoomType" [selectData]="roomType"
                    class="col-sm-6" type="multi-dropdown" text="{{'ROOM_TYPE'|translate}}">
                  </app-form-group>
                  <!-- Stockwerk -->
                  <app-form-group formControlName="floor" id="dropdownFloor" [selectData]="floor" class="col-sm-6"
                    type="multi-dropdown" text="{{'FLOOR'|translate}}">
                  </app-form-group>
                  <!-- Ausstattung -->
                  <app-form-group formControlName="equipments" id="dropdownInfrastructure" [selectData]="equipment"
                    class="col-sm-6" type="multi-dropdown" text="{{'INFRASTRUCTURE'|translate}}"></app-form-group>
                  <!-- Anzahl Personen -->
                  <app-form-group formControlName="seats" id="dropdownSeats" [selectData]="seats" class="col-sm-6"
                    type="multi-dropdown" text="{{'NUMBER_PERSONS'|translate}}">
                  </app-form-group>
                </div>
              </div>

            </div>

            <!-- FIXME: -->
            <!-- <pre>{{searchFormGroup.value|json}}</pre> -->

            <!-- buttons -->
            <div class="row mt-4">
              <div class="col">
                <div class="float-right">
                  <button type="button" (click)="onResetClick()"
                    class="btn btn-secondary mr-3">{{'BTN_RESET'|translate}}</button>
                  <button type="button" [disabled]="!searchFormGroup.valid" (click)="onSearchClick()"
                    class="btn btn-primary">{{'BTN_SEARCH'|translate}}</button>
                </div>
              </div>
              <!--EFHG-3756: Button für Favoriten für R6 ausbauen, ist nur ein nice to have. Code behalten! -->
              <!-- <div class="col text-right">
                <button type="button" class="btn btn-secondary" (click)="onSaveSearchClick()">{{'BTN_SAVE_SEARCH'|translate}}</button>
              </div> -->
            </div>

          </form>
        </div>
      </app-accordion-element-body>

    </div>

    <div [id]="accordionResultPanel" appAccordionElement>

      <div appAccordionElementHeader>
        <button type="button" appAccordionElementTrigger>{{'RESULT'|translate}}</button>
      </div>

      <app-accordion-element-body>
        <app-room-allocation-table [useReservationMode]="true" [useColumnsDataAsCaption]="true"
          [model]="allocationTableModel" [currentDate]="currentDate" [type]="resourceType" [isLoading]="isLoading"
          [emptyResultMessage]="'NO_ROOMS_FOUND'|translate" (createReservation)="onCreateReservation($event)"
          (navigateDate)="onNavigateDate($event)" (openSchedule)="onOpenSchedule($event)"
          timespanConflictMessageKey="ROOM_TIMELINE_OCCUPIED">
        </app-room-allocation-table>
      </app-accordion-element-body>

    </div>

  </div>

</div>


<!-- Reservation Dialog -->
<app-modal-dialog backdrop="static" #createReservationDialog title="{{'CREATE_ROOM_RESERVATION'|translate}}"
  [body]="modalCreateReservation" [showPositive]="false" [showCancel]="false" cancelButton="{{'CLOSE'|translate}}"
  size="lg"></app-modal-dialog>
<ng-template #modalCreateReservation>
  <app-messages></app-messages>
  <app-create-room-reservation-dialog [params]="createReservationParams" (saved)="onReservationSaved($event)">
  </app-create-room-reservation-dialog>
</ng-template>

<!-- Room Schedule Dialog -->
<app-modal-dialog #roomScheduleDialog title="{{'ROOM_CALENDAR'|translate}}" [body]="modalRoomSchedule"
  [showPositive]="false" cancelButton="{{'CLOSE'|translate}}" size="lg"></app-modal-dialog>
<ng-template #modalRoomSchedule>
  <app-room-schedule [ressourceInfo]="activeRessourceInfo" [roomId]="activeItemId" [currentDate]="currentDate"
    [type]="resourceType" (createReservation)="onCreateReservation($event)"></app-room-schedule>
</ng-template>

<app-spinner-overlay></app-spinner-overlay>